// User Groups translations for React Admin resource
export const userGroupsResource = {
  name: '用戶群組',
  fields: {
    id: '編號',
    name: '名稱',
    description: '說明',
    memberCount: '成員數',
    createdAt: '建立時間',
    updatedAt: '更新時間',
    createdBy: '建立者',
    updatedBy: '更新者',
    userId: '用戶',
    addedAt: '加入時間',
  },
};

// Custom user-groups translations for components
export const userGroups = {
  subtitle: '管理用作預約資格的用戶群組',
  sections: {
    basic: '基本資料',
    members: '成員',
    audit: '稽核紀錄',
  },
  list: {
    title: '用戶群組',
    subtitle: '管理用戶群組',
    searchPlaceholder: '按名稱或說明搜尋',
    noGroups: '尚未定義任何用戶群組',
    filters: {
      search: '搜尋',
    },
  },
  create: {
    title: '建立用戶群組',
    subtitle: '為預約資格定義新的用戶群組',
    backToList: '返回群組列表',
  },
  edit: {
    title: '編輯用戶群組',
    subtitle: '修改群組資料及成員',
    backToList: '返回群組列表',
  },
  show: {
    subtitle: '用戶群組詳情',
    tabs: {
      details: '詳細資料',
      members: '成員',
    },
  },
  members: {
    title: '群組成員',
    add: '加入成員',
    add_app_user: '加入應用程式用戶',
    add_rfid_user: '加入 RFID 用戶',
    remove: '移除',
    searchUsers: '以電郵、電話或編號搜尋用戶',
    searchRfidUsers: '以姓名、電郵或電話搜尋 RFID 用戶',
    selectUser: '選擇要加入的用戶',
    selectRfidUser: '選擇要加入的 RFID 用戶',
    confirmRemove: '確定將此用戶從群組移除嗎？',
    empty: '群組目前沒有成員',
    addedSuccess: '成員已加入群組',
    removedSuccess: '成員已從群組移除',
    duplicate: '此用戶已是群組成員',
    memberType: '類型',
    type: {
      app_user: '應用程式用戶',
      rfid_user: 'RFID 用戶',
    },
  },
  validation: {
    nameRequired: '名稱為必填',
    nameTooLong: '名稱不可超過 100 字元',
    descriptionTooLong: '說明不可超過 500 字元',
  },
  helpers: {
    name: '選擇一個具描述性的名稱（例如「VIP 客戶」、「測試版用戶」）',
    description: '描述此群組的用途',
  },
  notifications: {
    created: '用戶群組已成功建立',
    updated: '用戶群組已成功更新',
    deleted: '用戶群組已成功刪除',
    error: {
      create: '建立用戶群組失敗',
      update: '更新用戶群組失敗',
      delete: '刪除用戶群組失敗',
    },
  },
  actions: {
    create: '建立用戶群組',
    save: '儲存變更',
    delete: '刪除群組',
    addMember: '加入成員',
  },
};

export const userGroupsTranslations = {
  'user-groups': {
    ...userGroupsResource,
    ...userGroups,
  },
};
